import { createSlice } from "@reduxjs/toolkit";


const initialState={
    name:null,
    email:null,
    isSubscriberVip:null,
    isSubscriptionActive:null

}


const subscriberSlice=createSlice({
    name:"sunscriber",
    initialState,
    reducers:{
        setSubscriberInfo(state,action){
            state.name=action.payload.name
            state.email=action.payload.email
            state.isSubscriberVip=action.payload.isSubscriberVip
            state.isSubscriptionActive=action.payload.isSubscriptionActive

        },
        resetSubscriberInfo(state){
            state.name=null
            state.email=null
            state.isSubscriberVip=null
            state.isSubscriptionActive=null

        }
    }

})

export const {setSubscriberInfo,resetSubscriberInfo}=subscriberSlice.actions

export default subscriberSlice.reducer